var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-more-data",class:{ 'd-none': !_vm.isLoading },attrs:{"id":_vm.id}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 p-t-16 text-center"},[_c('div',{staticClass:"spinner-border text-secondary"})])
}]

export { render, staticRenderFns }